import {
  Autocomplete,
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  Stack,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../services/ApiService";
import boxStyles from "../../styles/boxStyles";

const HeaderUser = ({
  inputFields,
  setInputFields,
  readOnly = false,
  user,
  action,
}) => {
  const router = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (action == "read" || action == "edit") {
      setInputFields(user);
      getUsers(user.namaPegawai);
    } else {
      setInputFields({
        namaPegawai: "",
        email: "",
        jabatan: "",
        noPegawai: "",
        roleId: "",
        activeStatus: "",
      });
    }
    const getRoles = async () => {
      try {
        await ApiService.getListRoles().then((res) => {
          if (res.data.isOk) {
            setRoles(res.data.payload);
          } else {
            alert(res.data.message);
            // router("/");
          }
        });
      } catch (error) {
        alert("Error was occured " + error);
        // router("/");
      }
    };

    getRoles();
  }, []);

  const handleKeyDown = async (e) => {
    setLoading(true);
    if (e.key == "Enter" || e.key == " ") {
      await getUsers(e.target.value);
    }
    setLoading(false);
  };

  const getUsers = async (val) => {
    if (action !== "create") return;
    setLoading(true);
    try {
      await ApiService.getListUserAdmin(val).then((res) => {
        if (res.data.isOk) {
          setUsers(res.data.payload);
        } else {
          alert(res.data.message);
          setTimeout(() => {
            // router("/");
          }, 500);
        }
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      alert("The Error was occured", error);
      setTimeout(() => {
        // router("/");
      }, 500);
    }
  };

  const handleChosePegawai = (e, val) => {
    if (!val == null || val != undefined) {
      setInputFields({
        jabatan: val.jabatan,
        email: val.email,
        namaPegawai: val.namalengkap,
        noPegawai: val.employeeId,
        nopek: val.nopek,
        roleId: "",
        activeStatus: "",
      });
    } else {
      setInputFields({
        jabatan: "",
        email: "",
        namaPegawai: "",
        noPegawai: "",
        roleId: "",
        activeStatus: "",
      });
    }
  };

  const handleRoleId = (val) => {
    let result = null;
    result = roles.find((el) => el.id == val);
    if (!result == null || result != undefined) {
      setInputFields({
        ...inputFields,
        roleId: result.id,
      });
    }
  };

  return (
    <>
      <Box component="div" sx={boxStyles}>
        <Grid container spacing={3}>
          <Grid item xl={12} lg={12} sm={12} xs={12}>
            <Stack spacing={2}>
              {/* {loading ? (
                <Skeleton
                  variant="rectangular"
                  width={450}
                  height={50}
                  animation="wave"
                />
              ) :  */}
              {action == "create" ? (
                <FormControl fullWidth>
                  <Autocomplete
                    loading={loading}
                    name="idNamaPegawai"
                    onChange={(e, value) => handleChosePegawai(e, value)}
                    onKeyDown={handleKeyDown}
                    required
                    defaultValue={users.find(
                      (item) => item.id === inputFields.noPegawai
                    )}
                    getOptionLabel={(option) => option.namalengkap}
                    options={users}
                    renderInput={(params) => (
                      <TextField {...params} label="Nama Pegawai" />
                    )}
                    getOptionSelected={(option, value) =>
                      option.namalengkap === value.namalengkap
                    }
                  />
                </FormControl>
              ) : (
                ""
              )}
            </Stack>
          </Grid>
          <Grid item xl={12} lg={12} sm={12} xs={12}>
            <Stack spacing={2}>
              <TextField
                name="noPegawai"
                label="No. Pegawai"
                variant="standard"
                fullWidth
                value={inputFields.noPegawai ? inputFields.noPegawai : ""}
                InputLabelProps={{ shrink: inputFields.noPegawai !== "" }}
                disabled={readOnly}
              />
              <TextField
                name="namaPegawai"
                label="Nama Pegawai"
                variant="standard"
                fullWidth
                value={inputFields.namaPegawai ? inputFields.namaPegawai : ""}
                InputLabelProps={{ shrink: inputFields.namaPegawai !== "" }}
                onKeyDown={handleKeyDown}
                disabled={readOnly}
                onChange={(e) =>
                  setInputFields({
                    ...inputFields.namaPegawai,
                    namaPegawai: e.target.value,
                  })
                }
              />
              {action == "create" ? (
                <TextField
                  name="jabatan"
                  label="Jabatan"
                  variant="standard"
                  fullWidth
                  value={inputFields.jabatan ? inputFields.jabatan : ""}
                  InputLabelProps={{ shrink: inputFields.jabatan !== "" }}
                  onChange={(e) =>
                    setInputFields({
                      ...inputFields,
                      jabatan: e.target.value,
                    })
                  }
                  disabled={readOnly}
                />
              ) : (
                ""
              )}
              <TextField
                name="email"
                label="Email Pegawai"
                variant="standard"
                fullWidth
                value={inputFields.email ? inputFields.email : ""}
                InputLabelProps={{ shrink: inputFields.email !== "" }}
                disabled={readOnly}
              />
              <FormControl fullWidth>
                <InputLabel id="idRole">Role</InputLabel>
                <Select
                  labelId="role"
                  id="role"
                  label="Role"
                  value={inputFields.roleId}
                  onChange={(e) => handleRoleId(e.target.value)}
                  disabled={action == "read"}
                >
                  {roles.map((item, idx) => (
                    <MenuItem value={item.id} key={idx}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default HeaderUser;
